export default __webpack_public_path__ + "static/media/delete.aef56978.svg";